export default "__VITE_ASSET__adkdyAaF__"